/**
 * Generates and returns totally random hash string
 * @param {number} [length=16] - Length of the returned hash
 *
 * @returns {string} hash - Hash as random string
 */

function uniqueHash (length) {
  // If no length param added
  if (typeof length === 'undefined') {
    length = 16
  }

  const timestamp = +new Date()

  const _getRandomInt = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  const ts = timestamp.toString()
  const parts = ts.split('').reverse()
  let hash = ''

  for (let i = 0; i < length; ++i) {
    const index = _getRandomInt(0, parts.length - 1)
    hash += parts[index]
  }

  return hash
}

export default uniqueHash
